import { render, staticRenderFns } from "./orderinfo.vue?vue&type=template&id=5f090108&scoped=true"
import script from "./orderinfo.vue?vue&type=script&lang=js"
export * from "./orderinfo.vue?vue&type=script&lang=js"
import style0 from "./orderinfo.vue?vue&type=style&index=0&id=5f090108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f090108",
  null
  
)

export default component.exports